import { http } from "api/http";

const getBillingEntity = ({ queryKey }) => {
  return http.get("/billing-entities", { params: queryKey[1] });
};

const getActiveBillingEntity = () => {
  return http.get("/billing-entities/active");
};

const getActiveInactiveBillingEntity = ({ queryKey }) => {
  return http.get("/billing-entities/active-inactive", { params: queryKey[1] });
};


const createBillingEntity = (data: any) => {
  return http.post("/billing-entities", data);
};

const deleteBillingEntity = ({ id }: any) => {
  return http.delete(`/billing-entities/${id}`);
};

const activateDeactivateBillingEntity = ({ id, data }: any) => {
  return http.patch(`/billing-entities/status-change/${id}`, data);
}

const defaultBillingEntity = ({ id }: any) => {
  return http.patch(`/billing-entities/default/${id}`);
}

const updateBillingEntity = ({ data, id }: any) => {
  return http.patch(`/billing-entities/${id}`, data);
};

const getBillingEntityDetails = ({ queryKey }: any) => {
  return http.get(`/billing-entities/${queryKey[1]}`);
};


const getSignatureUsers = ({ queryKey }: any) => {
  return http.get(`/billing-entities/sign-users/${queryKey[1]}`)
}

const defaultSignature = ({ id, data }: any) => {
  return http.patch(`/billing-entities/default-sign/${id}`, data);
};


const updateSignatures = ({ id, data }: any) => {
  return http.patch(`billing-entities/sign-users/${id}`, data)
}



const createBankAccounts = (data: any) => {
  return http.post("/bank-accounts", data);
};

export {
  getBillingEntity,
  createBillingEntity,
  deleteBillingEntity,
  getBillingEntityDetails,
  updateBillingEntity,
  createBankAccounts,
  defaultBillingEntity,
  activateDeactivateBillingEntity,
  getActiveBillingEntity,
  getSignatureUsers,
  defaultSignature,
  updateSignatures,
  getActiveInactiveBillingEntity
};
